<script lang="ts" setup>
import { NuxtLinkProps } from 'nuxt/app'

export type VNuxtLinkTarget = '_blank' | '_self'

export interface VNuxtLinkProps extends NuxtLinkProps {
    to: VNuxtLinkTo
    target?: VNuxtLinkTarget
    external?: boolean
    label?: string
}
const props = withDefaults(defineProps<VNuxtLinkProps>(), {
    target: '_self',
    external: true,
    label: '',
})
const linkRef = ref<HTMLAnchorElement>()
defineExpose({ linkRef })

const { data, sendEvent } = useTracker()

const handleClick = () => {
    if (props.label) {
        sendEvent({
            data: {
                ...data,
                click: props.label,
            },
        })
    }
}
</script>
<template>
  <NuxtLink
    ref="linkRef"
    :to="props.to"
    :external="props.external"
    :no-rel="true"
    :target="props.target"
    :label="undefined"
    @click="handleClick"
  >
    <slot />
    <span
      v-if="props.target === '_blank'"
      class="visually-hidden"
    >{{ $t(" (externý odkaz)") }} 
    </span>
  </NuxtLink>
</template>
